import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT_APP } from 'store/sagas'

export const NAMESPACE = 'KanBo/personalDates/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_NAME = NAMESPACE + 'SET_NAME'
export const SET_TIMESTAMP = NAMESPACE + 'SET_TIMESTAMP'

const initialState = {
  ids: [],
  byId: {},
  isLoading: false,
  isLoaded: false
}

const itemDefaults = {
  name: ''
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT_APP:
      return {
        ...initialState
      }
    case SET_LOAD_STATUS:
      return {
        ...state,
        isLoading: action.payload.isLoading,
        isLoaded: action.payload.isLoaded
      }
    case ADD:
      return {
        ...state,
        ids: addUniqueValueToArray({
          array: state.ids,
          value: action.payload.id,
          index: action.payload.index
        }),
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...itemDefaults,
            ...action.payload
          }
        }
      }
    case ADD_ARRAY: {
      const newState = {
        ...state,
        ids: [ ...state.ids ],
        byId: { ...state.byId }
      }
      action.payload.forEach(item => {
        newState.ids = addUniqueValueToArray({
          array: newState.ids,
          value: item.id,
          index: item.index
        })
        newState.byId[item.id] = {
          ...itemDefaults,
          ...item
        }
      })
      return newState
    }
    case REMOVE: {
      const newState = {
        ...state,
        ids: [ ...state.ids.filter(id => id !== action.payload.id) ],
        byId: { ...state.byId }
      }
      delete newState.byId[action.payload.id]
      return newState
    }
    case SET_NAME:
      return state.byId[action.payload.id] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...state.byId[action.payload.id],
            name: action.payload.name
          }
        }
      } : state
    case SET_TIMESTAMP:
      return state.byId[action.payload.id] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...state.byId[action.payload.id],
            timestamp: action.payload.timestamp
          }
        }
      } : state
    default: return state
  }
}

export function setLoadStatus ({ isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      isLoading,
      isLoaded
    }
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (array) {
  return {
    type: ADD_ARRAY,
    payload: array
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export function setName ({ id, name }) {
  return {
    type: SET_NAME,
    payload: {
      id,
      name
    }
  }
}

export function setTimestamp ({ id, timestamp }) {
  return {
    type: SET_TIMESTAMP,
    payload: {
      id,
      timestamp
    }
  }
}
